module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAOCAYAAABpcp9aAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABYSURBVEhLY/j//78DEDcMVQzyAIgxZMGoBwYaDH8PJM/yGHCcsyAI6hpMQNADasUMA471KrigrsEEw98DoOgbaFyyNAbqGkww/DPxYAejHhhoMMQ98P8/APLuQ8XBa8GOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/gravityMains.png
// module id = 132
// module chunks = 0